import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {hasData} from "../utils";
import colors from "../constants/colors";
import 'typeface-barlow';
import { Tooltip } from '../index'

const TEXTAREA = styled.textarea`
  height: 100px;
  width: 400px;
  font-size: 14px;
  border-radius: 4px;
  margin-right: 5px;
  padding: 15px;
  outline: 0;
  border: 2px solid ${(props) => props.borderColor};
  color: ${(props) => props.fontColor};
  background: ${(props) => props.backgroundColor};
  position: relative;
  opacity: .9;
  font-family: Barlow;
  
  &:hover {
    opacity: 1;
    // cursor: pointer;
  }
  
  &[disabled] {
    opacity: .5;
  }
`;

const LOADING = styled.span`
  position: absolute;
  bottom: 3px;
  left: 15px;
`;

function StyleTextArea(props) {
  const [loading, setLoading] = useState(false);
  const [loadingSteps, setLoadingSteps] = useState(0);
  const [loadingString, setLoadingString] = useState(null);

  useEffect(() => {
    setLoading(props.loading)
  },[props.loading]);

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        if (loadingSteps === 15) {
          setLoadingSteps(0);
        } else {
          setLoadingSteps(loadingSteps + 1);
        }
      }, 200);
    }
  }, [loading, loadingSteps]);

  useEffect(() => {
    let i = 0;
    let s = '';
    while (i < loadingSteps) {
      i++;
      s = `${s}.`;
    }
    setLoadingString(<LOADING>{s}</LOADING>)
  }, [loadingSteps]);

  let fontColor = colors.brownGrey;
  let backgroundColor = colors.lightWhite;

  if (props.color === 'red') {
    fontColor = colors.white;
    backgroundColor = colors.salmon;
  }

  if (props.color === 'green') {
    fontColor = colors.white;
    backgroundColor = colors.tea;
  }

  if (props.color === 'blue') {
    fontColor = colors.white;
    backgroundColor = colors.softBlue;
  }

  if (props.color === 'orange') {
    fontColor = colors.white;
    backgroundColor = colors.orange;
  }

  if (props.color === 'purple') {
    fontColor = colors.white;
    backgroundColor = colors.lighterPurple;
  }

  if (props.color === 'black') {
    fontColor = colors.white;
    backgroundColor = colors.greyishBrown;
  }

  let borderColor = backgroundColor;

  if (hasData(props.hollow)) {
    borderColor = backgroundColor;
    fontColor = backgroundColor;
    backgroundColor = 'transparent';

    if (!hasData(props.color)) {
      fontColor = colors.brownGrey;
      borderColor = fontColor;
    }
  }

  const textarea = (
    <TEXTAREA
      fontColor={fontColor}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      onClick={props.onClick !== undefined ? (e) => props.onClick(e) : null}
      onChange={props.onChange !== undefined ? (e) => props.onChange(e) : null}
      disabled={props.disabled}
      style={props.style}
      data-tour={hasData(props.tour) ? props.tour : null}
      className={hasData(props.className) ? props.className : null}
      placeholder={hasData(props.placeholder) ? props.placeholder : loadingString}
      value={props.value}
      defaultValue={props.defaultValue}
    />
  );

  // display a tooltip if configured
  if (hasData(props.toolTip)) {
    return (
      <Tooltip message={props.toolTip} position={hasData(props.toolTipPosition) ? props.toolTipPosition : 'top'} color={hasData(props.toolTipColor) ? props.toolTipColor : 'black'}>
        {textarea}
      </Tooltip>
    );
  } else {
    return textarea;
  }
}

StyleTextArea.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  hollow: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  toolTip: PropTypes.string,
  toolTipColor: PropTypes.string,
  toolTipPosition: PropTypes.string,
};

export default StyleTextArea;
